import { render, staticRenderFns } from "./CoursewareNote.vue?vue&type=template&id=153eef5d&scoped=true&"
import script from "./CoursewareNote.vue?vue&type=script&lang=js&"
export * from "./CoursewareNote.vue?vue&type=script&lang=js&"
import style0 from "./CoursewareNote.vue?vue&type=style&index=0&id=153eef5d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153eef5d",
  null
  
)

export default component.exports